import {Editor} from '@tiptap/react';
import {
    EDITOR_MODE,
    EditorModeType,
    ISetDebounceChangeHandlerAction,
    ISetEditorAction,
    ISetEditorMode,
    SET_DEBOUNCE_CHANGE_HANDLER,
    SET_EDITOR,
} from './types/tiptapEditor.types';

export const setEditorAction = (id: string, editor: Editor): ISetEditorAction => ({
    type: SET_EDITOR,
    payload: {id, editor},
});

export const setDebounceChangeHandler = (id: string, handler: (updatedContent: string) => void): ISetDebounceChangeHandlerAction => ({
    type: SET_DEBOUNCE_CHANGE_HANDLER,
    payload: {id, handler},
});

export const setEditorMode = (mode: EditorModeType): ISetEditorMode => ({
    type: EDITOR_MODE,
    payload: {mode},
});
